export const sessionKeys = {
  probe: ["session", "probe"] as const,
  customer: ["session", "customer"] as const,
}
